import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import SearchFeed from "../components/search/SearchFeed";
import "./searchPage.css";

/**
 * SearchPage Component
 * Página principal para o sistema de busca da aplicação
 * Fornece contexto completo e integração com navegação
 */
const SearchPage = ({ setVisible }) => {
  const user = useSelector((state) => state.user);
  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    // Simular carregamento da página
    setPageLoaded(true);

    // Analytics: Registrar visualização da página de pesquisa
    if (user?._id) {
      console.log(`[SearchPage] User ${user._id} accessed search page`);
    }

    return () => {
      setPageLoaded(false);
    };
  }, [user?._id]);

  if (!pageLoaded) {
    return (
      <div className="search-page loading">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div className="search-page">
      <div className="search-page-container">
        {/* Header */}
        <div className="search-page-header">
          <div className="search-header-content">
            <h1>🔍 Sistema de Pesquisa</h1>
            <p>Encontre exercícios, usuários, blogs, lookbooks e muito mais</p>
          </div>
        </div>

        {/* Main Search Component */}
        <div className="search-page-content">
          <SearchFeed />
        </div>

        {/* Footer Tips */}
        <div className="search-page-footer">
          <div className="footer-tips">
            <h3>💡 Dicas de Pesquisa</h3>
            <ul>
              <li>Use aspas para buscar frases exatas: "yoga para iniciantes"</li>
              <li>Combine termos com AND, OR para refinar resultados</li>
              <li>Clique em "Salvar" para guardar pesquisas favoritas</li>
              <li>Veja suas pesquisas salvas na aba "Pesquisas Salvas"</li>
              <li>Acesse histórico na aba "Histórico" para voltar rapidamente</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchPage;
